var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.611,
    height: 15.613,
    viewBox: "0 0 15.611 15.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-close",
    "data-name": "Icon material-close",
    d: "M23.112,9.072,21.54,7.5l-6.234,6.234L9.072,7.5,7.5,9.072l6.234,6.234L7.5,21.54l1.572,1.572,6.234-6.234,6.234,6.234,1.572-1.572-6.234-6.234Z",
    transform: "translate(-7.5 -7.5)",
    fill: "#1d1d1d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.51a8e28b6fc3e2df389ae82da38d1e83.svg";
export { ForwardRef as ReactComponent };